<div style="width: 95%;" [attr.dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'">
    <div mat-dialog-title class="modal-header-bg d-flex justify-content-end px-3 pt-1"></div>
    <div mat-dialog-content>
      <h4 class="font-weight-bold title-text">
        {{ "complaint-modal-title" | translate }}
        <img src="assets/img/Complaint.svg" alt="Complaint" class="withdraw-icon">
      </h4>
      <p class="text-muted-special subtitle-text">{{ "complaint-modal-subtitle" | translate }}</p>
  
      <div class="settings-profile">
        <!-- <div class="stepper-overlay" *ngIf="!selectedAccount">
          <div class="overlay-content">
            {{ "choose-account" | translate }}
          </div>
        </div> -->
        <form #complaintForm="ngForm" (ngSubmit)="submitComplaint(complaintForm)">
          <div class="form-row">
            <div class="col-md-12 mb-3" *ngIf="showDepartment">
              <label class="required form-field-title">{{ "department" | translate }}</label>
              <ng-select [searchable]="false" class="custom" #DepartmentId="ngModel" ngModel name="DepartmentId" [dropdownPosition]="'bottom'" required [placeholder]="'department' | translate">
                <ng-option *ngFor="let department of departments" [value]="department.DepartmentID">
                  {{ translate.currentLang == "en" ? department.DepartmentNameE : department.DepartmentNameA }}
                </ng-option>
              </ng-select>
            </div>
            <div class="col-md-12 mb-3">
              <label class="required form-field-title">{{ "complaint-body" | translate }}</label>
              <textarea [placeholder]="'complaint-body' | translate" [(ngModel)]="newComplaint.Body" #Body="ngModel" name="Body" class="form-control notes-textarea" rows="4" required autocomplete="off"
              autocorrect="off"
              spellcheck="false"
></textarea>
            </div>
          </div>
          <div class="col-12 d-flex justify-content-end" style="justify-content: end">
            <button class="btn btn-primary align-self-center mt-4" type="submit" [disabled]="complaintForm.invalid || isSubmitting || !selectedAccount">
              <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm"></span>
              {{ "send" | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>